"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Overflow = function Overflow() {
  return _react2.default.createElement(
    "g",
    { id: "overflow" },
    _react2.default.createElement("path", {
      d: "M313,62.5 C313,27.9822031 285.017797,2.11360547e-15 250.5,0 C215.982203,-2.11360547e-15 188,27.9822031 188,62.5 C188,97.0177969 215.982203,125 250.5,125 C267.077657,125.005307 282.977861,118.422209 294.700035,106.700035 C306.422209,94.9778605 313.005307,79.0776571 313,62.5 Z M313,250 C313,215.482203 285.017797,187.5 250.5,187.5 C215.982203,187.5 188,215.482203 188,250 C188,284.517797 215.982203,312.5 250.5,312.5 C267.077657,312.505307 282.977861,305.922209 294.700035,294.200035 C306.422209,282.477861 313.005307,266.577657 313,250 Z M313,437.5 C313,402.982203 285.017797,375 250.5,375 C215.982203,375 188,402.982203 188,437.5 C188,472.017797 215.982203,500 250.5,500 C267.077657,500.005307 282.977861,493.422209 294.700035,481.700035 C306.422209,469.977861 313.005307,454.077657 313,437.5 Z",
      id: "Combined-Shape"
    })
  );
};

exports.default = Overflow;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Overflow.js
// module id = 2974
// module chunks = 4